export default "__VITE_ASSET__BoTlJRfy__"